import React, { Suspense, lazy } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { SocialProofStrip } from './components/SocialProofStrip';
import { PainSection } from './components/PainSection';
import { SystemIntro } from './components/SystemIntro';
import { TomosSection } from './components/TomosSection';

// Todo lo que está muy por debajo del pliegue se carga en chunks aparte,
// para que el bundle inicial solo tenga lo visible al entrar.
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const UrgencySection = lazy(() => import('./components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Sistema360Section = lazy(() => import('./components/Sistema360Section').then(m => ({
  default: m.Sistema360Section
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalSection = lazy(() => import('./components/FinalSection').then(m => ({
  default: m.FinalSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyCta = lazy(() => import('./components/StickyCta').then(m => ({
  default: m.StickyCta
})));
export function App() {
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="3dlw9sfqkejd6">
      <TopBar data-id="element-1" data-mp="3dii716dzo857" />
      <Hero data-id="element-2" data-mp="nvstj3irmlvf" />
      <StatsBar data-id="element-3" data-mp="nwc23tmizxws" />
      <main data-id="element-4" data-mp="nur7k407oeyx">
        <SocialProofStrip data-id="element-5" data-mp="nv0xxsp64o55" />
        <PainSection data-id="element-6" data-mp="nxwvvh10nctl" />
        <SystemIntro data-id="element-7" data-mp="sudnwmbc6bby" />
        <TomosSection data-id="element-8" data-mp="stkne32z0i29" />
        <Suspense fallback={<div className="min-h-[60vh] w-full bg-forest-50" aria-hidden="true" data-id="element-10" data-mp="swqbbezv5dwe" />} data-id="element-9" data-mp="st2hsfuf4rho">
          <BonosSection data-id="element-11" data-mp="34napqbl6vw3" />
          <UrgencySection data-id="element-12" data-mp="38b2ajxh1886" />
          <PricingSection data-id="element-13" data-mp="3udaxmaph6r5r" />
          <Sistema360Section data-id="element-14" data-mp="3ubztuaw15jen" />
          <TestimonialsSection data-id="element-15" data-mp="3uevui6z9im6s" />
          <GuaranteeSection data-id="element-16" data-mp="d57hf8hvkslp" />
          <FaqSection data-id="element-17" data-mp="d3cvbquvaug1" />
          <FinalSection data-id="element-18" data-mp="d3wa4yp812pu" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-19" data-mp="85bd1859mz5m">
        <Footer data-id="element-20" data-mp="86cnpbiddjmt" />
        <StickyCta data-id="element-21" data-mp="83i6rtykegy5" />
      </Suspense>
    </div>;
}